(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-persona', {
            parent: 'entity',
            url: '/ss-persona',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPersonas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-persona/s-s-personas.html',
                    controller: 'SSPersonaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-persona-detail', {
            parent: 'ss-persona',
            url: '/ss-persona/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPersona'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-persona/ss-persona-detail.html',
                    controller: 'SSPersonaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSPersona', function($stateParams, SSPersona) {
                    return SSPersona.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-persona',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-persona-detail.edit', {
            parent: 'ss-persona-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-dialog.html',
                    controller: 'SSPersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPersona', function(SSPersona) {
                            return SSPersona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-persona.new', {
            parent: 'ss-persona',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-dialog.html',
                    controller: 'SSPersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombres: null,
                                primerApellido: null,
                                segundoApellido: null,
                                sexo: null,
                                titulo: null,
                                telefono: null,
                                telefono2: null,
                                email: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-persona', null, { reload: 'ss-persona' });
                }, function() {
                    $state.go('ss-persona');
                });
            }]
        })
        .state('ss-persona.edit', {
            parent: 'ss-persona',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-dialog.html',
                    controller: 'SSPersonaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPersona', function(SSPersona) {
                            return SSPersona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-persona', null, { reload: 'ss-persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-persona.delete', {
            parent: 'ss-persona',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-persona/ss-persona-delete-dialog.html',
                    controller: 'SSPersonaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSPersona', function(SSPersona) {
                            return SSPersona.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-persona', null, { reload: 'ss-persona' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
